import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin, ArrowRight } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img
                src={companyInfo.logo}
                alt="PD Media"
                className="h-14 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              A trusted marketing, promotion, and technology company delivering AI-powered solutions for over a decade.
            </p>
            <div className="flex space-x-3">
              <a
                href={companyInfo.instagramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 bg-white/5 rounded-lg hover:bg-blue-600 transition-colors group"
              >
                <Instagram className="w-5 h-5 text-gray-400 group-hover:text-white" />
              </a>
              <a
                href={companyInfo.facebookLink}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 bg-white/5 rounded-lg hover:bg-blue-600 transition-colors group"
              >
                <Facebook className="w-5 h-5 text-gray-400 group-hover:text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'About', 'Services', 'Get Quote', 'Contact'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : item === 'Get Quote' ? '/quote' : `/${item.toLowerCase()}`}
                    className="text-gray-400 hover:text-blue-400 transition-colors text-sm flex items-center group"
                  >
                    <ArrowRight className="w-3 h-3 mr-2 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6">Our Services</h4>
            <ul className="space-y-3">
              {['Digital Marketing', 'Website Development', 'AI Solutions', 'Photography', 'Public Relations'].map((item) => (
                <li key={item}>
                  <Link
                    to="/services"
                    className="text-gray-400 hover:text-blue-400 transition-colors text-sm flex items-center group"
                  >
                    <ArrowRight className="w-3 h-3 mr-2 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <div className="p-2 bg-blue-600/10 rounded-lg">
                  <Phone className="w-4 h-4 text-blue-400" />
                </div>
                <div>
                  <p className="text-gray-500 text-xs">Phone</p>
                  <a href={`tel:${companyInfo.phone}`} className="text-gray-300 text-sm hover:text-blue-400">
                    {companyInfo.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <div className="p-2 bg-blue-600/10 rounded-lg">
                  <Mail className="w-4 h-4 text-blue-400" />
                </div>
                <div>
                  <p className="text-gray-500 text-xs">Email</p>
                  <a href={`mailto:${companyInfo.email}`} className="text-gray-300 text-sm hover:text-blue-400">
                    {companyInfo.email}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <div className="p-2 bg-blue-600/10 rounded-lg">
                  <MapPin className="w-4 h-4 text-blue-400" />
                </div>
                <div>
                  <p className="text-gray-500 text-xs">Location</p>
                  <span className="text-gray-300 text-sm">Serving across India</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-gray-500 text-sm">
              © {currentYear} PD Media. All rights reserved.
            </p>
            <p className="text-gray-500 text-sm">
              {companyInfo.workingHours}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
